import { Badge } from '@dreamtree-org/twreact-ui';
import { readinessFlag } from '../lib/listing';

/** Publish readiness as one badge (MERCH-58); what is missing is its hover text. `result` undefined → loading. */
export default function ReadinessBadge({ result }) {
  const flag = readinessFlag(result);
  if (!flag) return <span className="text-xs opacity-60">…</span>;
  const why = result.ready ? 'Ready to publish' : (result.missing || []).map((m) => m.detail || m.label).join(' ');
  return <span title={why}><Badge size="sm" variant={flag.variant}>{flag.label}</Badge></span>;
}
